var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRbRulebookFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0H24V24H0z",
    transform: "translate(-53.001 -1369) translate(53.001 1369)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.643 3.464a.822.822 0 0 1 .821-.821h15.607v18.071h1.643V1H4.464A2.465 2.465 0 0 0 2 3.464v18.072A2.465 2.465 0 0 0 4.464 24h13.965V4.286H4.464a.822.822 0 0 1-.821-.822z",
    transform: "translate(-53.001 -1369) translate(53.143 1367.5) translate(0 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRbRulebookFilled);
export default __webpack_public_path__ + "static/media/rb-rulebook-filled.776683d91224598afa3dcb31f87fb6af.svg";
export { ForwardRef as ReactComponent };